import { $t } from '@teachino/shared-i18n';

export const aiLanguageValues = [
  'de',
  'en',
  'it',
  'es',
  'fr',
  'pt',
  'tr',
  'po',
  'nl',
  'se',
  'ru',
  'sl',
  'cs',
  'lb',
  'ro',
  'rs',
  'hr',
  'sq',
  'hi',
  'ur',
  'ar',
] as const;
export type AiLanguage = (typeof aiLanguageValues)[number];

export const localisedLanguages = aiLanguageValues
  .map((code) => {
    const key = `language.${code}` as const;
    return $t(key);
  })
  .sort();

export const localisedLanguageMap: { id: string; label: string }[] =
  aiLanguageValues.map((code) => {
    return {
      id: code,
      label: $t(`language.${code}`),
    };
  });
